import React from "react";

import "./RangeControl.scss";

type RangeControlProps = {
  innerRef: any;
};

function UIRangeControl({
  innerRef,
  ...props
}: JSX.IntrinsicAttributes &
  React.ClassAttributes<HTMLInputElement> &
  React.InputHTMLAttributes<HTMLInputElement> &
  RangeControlProps) {
  return (
    <div className="range-control">
      <span>
        <input type="range" {...props} ref={innerRef} />
        <span>{props.value}</span>
      </span>
    </div>
  );
}

export default UIRangeControl;
